/* Ask-us popup on the v2 product page -- sections/pdp-buy.liquid.
   Everything else in that section is either the theme's own machinery or plain CSS;
   this file exists only because <dialog> needs showModal() called on it.

   Esc-to-close, the focus trap and returning focus to the trigger are native <dialog>
   behaviour and are deliberately not reimplemented here.

   Delegated from the document rather than bound per button: the theme re-renders parts
   of the buy column on every variant change (component-product-information.js swaps the
   innerHTML of anything carrying data-update-id), so a listener bound to an element
   found at load time would be attached to a node that no longer exists. Delegation
   survives that; this is the same class of bug docs/liquid-traps.md warns about. */

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-pdp-ask-open]');
  if (opener) {
    const dialog = opener.parentElement?.querySelector('[data-pdp-ask]');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closer = event.target.closest('[data-pdp-ask-close]');
  if (closer) closer.closest('[data-pdp-ask]')?.close();
});

/* Clicking the backdrop closes it. The dialog element covers the whole viewport while
   open, so a click that lands outside its content box is a backdrop click. */
document.addEventListener('click', (event) => {
  const dialog = event.target.closest?.('[data-pdp-ask]');
  if (!dialog || !dialog.open) return;
  const box = dialog.getBoundingClientRect();
  const outside =
    event.clientX < box.left ||
    event.clientX > box.right ||
    event.clientY < box.top ||
    event.clientY > box.bottom;
  if (outside) dialog.close();
});
